import React, { useEffect } from "react";
import NavBar from "../component/NavBar";
import Footer from "../component/Footer";
import UrlParamChecker from "../component/UrlChecker";

const TourSingle = () => {
  return (
    <div>
      <NavBar />
      <main id="main">

        <section id="tour" className="innerPage" style={UrlParamChecker() ? { marginTop: "16px", paddingTop: "0" } : {}}>
          <div className="container">
            <div className="section-title">
              <h2>Guided Tours</h2>
            </div>
            <h3>Bond Basics</h3>

            <div className="row">
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Bond Basics.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">Bond Basics</h5>

              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Factors Affecting G-Sec Prices.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">Factors Affecting G-Sec Prices</h5>
              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/G-Sec Returns.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">G-Sec Returns</h5>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Price Yield Relationship.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">Price Yield Relationship</h5>
              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Pricing of G-Secs.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">Pricing of G-Secs</h5>
              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted >
                  <source src="assets/videos/Risks on G-Secs.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title">Risks on G-Secs</h5>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Time Value of Money.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title"><span>Time Value of Money</span></h5>
              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Types of G-Secs.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title"><span>Types of G-Secs</span></h5>
              </div>
              <div className="col-lg-4 video">
                <video width="100%" controls muted>
                  <source src="assets/videos/Yield Curves.mp4" type="video/mp4" />
                  {/* <!-- <source src="movie.ogg" type="video/ogg"> --> */}
                  Your browser does not support the video tag.
                </video>
                <h5 className="video-title"><span>Yield Curves</span></h5>
              </div>
            </div>

          </div>
        </section>

      </main>
      <Footer />
    </div>
  );
};

export default TourSingle;
